import axios from "../AxiosInterCeptor/AxiosInterCeptor";
import { ToastError, ToastSuccess } from "../UiComponents/Toaster/Toast";

const URL = process.env.React_App_BaseUrl;

const PostBulkUploadJob = (data) => {
    return axios
        .post(`${URL}/bulkUploadJob`, data)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message || "Failed to create bulk upload job");
                return { error: true, message: res.message };
            } else {
                ToastSuccess("Job created successfully");
                return res;
            }
        })
        .catch((error) => {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to create bulk upload job";
            ToastError(message);
            return { error: true, message };
        });
};

const GetBulkUploadJob = (data) => {
    return axios
        .post(`${URL}/getBulkUploadJob`, data)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                console.log(res.error);
                return { error: true, message: res.message };
            } else {
                return res;
            }
        })
        .catch((error) => {
            console.log(error);
            return { error: true, message: error.message };
        });
};

const UpdateBulkUploadJob = (id, data) => {
    return axios
        .put(`${URL}/bulkUploadJob/${id}`, data)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message || "Failed to update job");
                return { error: true, message: res.message };
            } else {
                return res;
            }
        })
        .catch((error) => {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to update job";
            ToastError(message);
            return { error: true, message };
        });
};

const DeleteBulkUploadJob = (id) => {
    return axios
        .delete(`${URL}/bulkUploadJob/${id}`)
        .then((response) => {
            const res = response.data;
            if (res.error) {
                ToastError(res.message || "Failed to delete job");
                return { error: true, message: res.message };
            } else {
                ToastSuccess("Job deleted successfully");
                return res;
            }
        })
        .catch((error) => {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Failed to delete job";
            ToastError(message);
            return { error: true, message };
        });
};

export {
    PostBulkUploadJob,
    GetBulkUploadJob,
    UpdateBulkUploadJob,
    DeleteBulkUploadJob,
};
